// extracted by mini-css-extract-plugin
export default {"banner":"styles-module__banner--awlEo","closeButton":"styles-module__closeButton--YcDSN"};